import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { confirmSignUp, resendSignUpCode } from 'aws-amplify/auth'; // AWS Amplify functions
import { useToast } from '../context/ToastContext';
import { ROUTES } from '../constants/routes';

const VerifyAccount: React.FC = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();

  const [confirmationCode, setConfirmationCode] = useState('');
  const [error, setError] = useState('');
  const [resendLoading, setResendLoading] = useState(false); // Loading state for resend button
  const [resendError, setResendError] = useState(''); // Error state for resend
  const { email } = useParams<{ email: string }>();


  const handleConfirmSignUp = async () => {
    if (email) {
        try {
            await confirmSignUp({ username: email, confirmationCode: confirmationCode}); // Confirm the user's email with the confirmation code
            addToast('Account confirmed successfully! You can now log in.', false);
            navigate(ROUTES.LOGIN); // Redirect to login page after confirmation
          } catch (err) {
            console.error('Error confirming sign-up:', err);
            setError('Error confirming account. Please check your code and try again.');
          }
    } else {
        addToast('No email set', true);
        navigate(ROUTES.LOGIN);
    }
  };

  const handleResendCode = async () => {
    setResendLoading(true);
    if (email) {
        try {
            await resendSignUpCode({username: email});
            addToast('Confirmation code resent successfully! Please check your email.', false);
            setResendLoading(false);
          } catch (err) {
            console.error('Error resending confirmation code:', err);
            setResendError('Error resending confirmation code. Please try again later.');
            setResendLoading(false);
          }
    } else {
        addToast('No email set', true);
        navigate(ROUTES.LOGIN);
    }
  };

  return (
    <div style={{width: '100%', justifyContent: 'center', display: 'flex'}}>
    <div className="card" style={{marginTop: '40px', maxWidth: '800px', width: '500px', minWidth: '300px', backgroundColor: 'white'}}>
      <h2>Verify Your Account</h2>
      <p>Please enter the confirmation code sent to your email.</p>

      <div>
        <label>Confirmation Code:</label>
        <input
          type="text"
          value={confirmationCode}
          onChange={(e) => setConfirmationCode(e.target.value)}
          required
        />
        <br/>
        {error && <span className="error">{error}</span>}
      </div>
    <div className="buttonsRow">
        <div>
        {resendError && <span className="error">{resendError}</span>}
        <button 
          type="button" 
          onClick={handleResendCode} 
          disabled={resendLoading}
        >
          {resendLoading ? 'Resending...' : 'Resend Code'}
        </button>
      </div>
      <button type="button" onClick={handleConfirmSignUp}>Confirm Account</button>


      </div>
    </div>
    </div>
  );
};

export default VerifyAccount;
